module.exports = __webpack_public_path__ + "static/media/NV.8d72aabd.webp";